var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-target-details-container" },
    [
      _c(
        "div",
        { staticClass: "p-6 space-y-4", attrs: { id: "target-details" } },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-4" },
            [
              _c("BlTextSubtitle1", { attrs: { text: "Details" } }),
              _vm._v(" "),
              !_vm.readonly
                ? _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", label: "Edit" },
                    on: { clicked: _vm.onOpenEditDetails }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "space-y-5" }, [
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Title" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass: "col-span-3 text-grey",
                  attrs: { text: _vm.task.title }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Code" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass: "col-span-3 text-grey",
                  attrs: { text: _vm.task.code }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Curriculum" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex col-span-3 gap-2" },
                  [
                    _c("div", {
                      staticClass: "flex-shrink-0 rounded-full w-5 h-5 mt-0.5",
                      style: { backgroundColor: _vm.target.curriculum_color }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "text-grey",
                      attrs: { text: _vm.target.curriculum_name }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid items-center grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  attrs: { text: "Data collection method" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass: "col-span-3 text-grey",
                  attrs: { text: "Skill-Based Treatment (SBT)" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Graph color" }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "w-24 h-1 col-span-3",
                  style: { backgroundColor: _vm.task.color }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Description" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass:
                    "col-span-3 text-base whitespace-pre-line text-grey",
                  attrs: { text: _vm.task.description || "-" }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.editDetailsOpened
        ? _c("EditTaskDetailsModal", {
            attrs: { target: _vm.target, task: _vm.task },
            on: {
              "close-modal": function($event) {
                _vm.editDetailsOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66331ac1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66331ac1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/TaskPropertyDetails.vue
// module id = null
// module chunks = 